"use client";

import Image from "next/image";
import Link from "next/link";
import "./style.css";

export default function Subscribe() {
  return (
    <div className="col-lg-12 mt-lg-4 gh-sidebar-main w-100 gh-sidebar-subscribe">
      <div className="gh-sidebar-cta-container">
        {/* Background Image */}
        <Image
          src="/Newsletter-coinccino-signup.webp"
          alt="Subscribe Newsletter"
          fill
          className="gh-sidebar-cta-image"
          priority
        />

        {/* Content */}
        <div className="gh-sidebar-cta-content p-3">
          <span className="gh-sidebar-cta-text">
            SUBSCRIBE TO THE NEWSLETTER
          </span>

          <span className="gh-sidebar-cta-subtext">
            Coinccino brings you the weekly summary of major Web3-related news.
          </span>

          <Link
            href="/subscribe"
            className="newsletter-subscribe-button  text-center uppercase"
          >
            Subscribe
          </Link>
        </div>
      </div>
    </div>
  );
}
